// Copyright 2025 - Hewlett Packard Enterprise Company
import { useRef } from 'react';
import { Box } from 'grommet';
import useFlags from './hooks/useFlags';
import LoadingSpinner from './components/LoadingSpinner/LoadingSpinner';
import { setApiUrls } from './actions/api/api-constants';

const spinner = (
  <Box align="center" pad="small">
    <LoadingSpinner size="medium" />
  </Box>
);

export default function ApiRootUpdater({ children }) {
  const flagRef = useRef(null);
  const flags = useFlags();
  const singleHostApi = flags.T_20250129_59794_UI_API_SINGLEHOST();
  if (flagRef.current === null || flagRef.current !== singleHostApi) {
    const COM_API_ROOT_URL = singleHostApi
      ? `${window.indigo.REACT_APP_COM_CLOUDFRONT_ROOT_URL}${window.indigo.REACT_APP_COM_API_PATH}`
      : window.indigo.REACT_APP_COM_API_ROOT_URL;
    setApiUrls(COM_API_ROOT_URL);

    flagRef.current = singleHostApi;
  }

  return children;
}
